<template>
  <div
      v-if="modelValue && Object.keys(modelValue).length > 0"
      class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-5 g-3"
  >
    <div
        v-for="(image, index) in modelValue"
        :key="index"
        class="col "
    >
      <div
        class=" ratio ratio-1x1 d-flex justify-content-center align-items-center"
      >
        <div
          class="mw-100 mh-100 overflow-hidden"
        >
          <image-component
              :image-id="image"
              :is_preview_only="true"
              :is_lightbox="true"
              thumb_class="w-100 h-100"
          />
        </div>
     </div>

      <div
        class="mt-1"
      >
        <div
            @click.prevent="removeImage(index)"
        >
          <i class="bi bi-trash"/>
          <span
              class="ms-1"
          >
            {{$t('gallery.list.image.remove.title')}}
        </span>
        </div>

      </div>


    </div>
  </div>
  <div
    v-else
  >
    <div
      class="d-flex justify-content-center align-items-center"
    >

      <div
        class="d-flex justify-content-center align-items-center text-danger py-4"
      >
        <i class="bi bi-exclamation-triangle me-2 fs-4"/>
        <span
        >
          {{$t('gallery.list.empty.title')}}
        </span>
      </div>

    </div>




  </div>


  <div
    class="mt-3 form-group position-relative"
  >
    <div
        v-if="status.is_loading"
        class="position-absolute z-2 top-0 start-0 w-100 h-100 bg-white opacity-75 d-flex justify-content-center align-items-center"
    >
      <div
      class="d-flex justify-content-center align-items-center"
      >
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">
            {{$t('gallery.form.upload.loading.title')}}
         </span>
        </div>
<!--
        <span class="ms-2">{{$t('form_general.wait_processing_request_title')}}</span>
    -->
      </div>
    </div>


    <div class="input-group mb-3 position-relative">
      <input
          ref="uploadButton"
          @change="handleFileUpload"
          type="file"
          multiple
          accept="image/*"
          placeholder="Pridat obrazky"
          class="form-control"
      />

      <button
          v-if="status.is_upload_btn"
          @click.prevent="uploadImages()"
          class="btn btn-outline-secondary"
          type="button"
      >
        {{$t('gallery.form.upload.btn_title')}}
      </button>
    </div>

<!--
    <display-debug>
      <template #debugView>
        inputObj: {{ inputObj }}
      </template>
    </display-debug>
    -->

  </div>

<!--
  <display-debug>
    <template #debugView>
      inputObj: {{ inputObj }}
    </template>
  </display-debug>
  -->
</template>



<script>
import ImageComponent from "@/components/general/Image";
import axios from "axios";
export default {
  name: "MultiImageInput",
  components: {
    ImageComponent,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [String, Number, Object],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      uploadImagesFiles: [],
      status: {
        is_upload: false,
        is_upload_btn: false,
        is_error: false,
        is_loading: false,
      },
      error: null,
      inputModel: 20,
    }
  },
  mounted() {
   this.inputModel = this.inputObj.val;
  },
  methods: {
    removeImage(index) {
      //console.log("REMOVE IMAGE", index, this.modelValue[index])
      if (confirm("Opravdu odstanit tento obrazek?") === true){
        this.modelValue.splice(index, 1)
      }
    },
    async uploadImages() {
      //console.log("dev.uploadImages", this.uploadImagesFiles)
      for(const i in this.uploadImagesFiles) {
        this.is_loading = true;
        let formData = new FormData();
        formData.append('image_file', this.uploadImagesFiles[i] );
        formData.append('image_type', this.inputObj.params.image_type_id);
        formData.append('image_validate', 0 );

        axios.defaults.baseURL = this.getBaseRoot();
        await axios.post(
            this.getApiConfig('image.upload_service.path'), //this.cfg.api.image.upload_service.path,
            formData,
            {
              headers: this.getRequestHeaderUpload()
            }
        ).then((res) => {
          if(
              res.data.response.id
          ) {
            this.modelValue.push(
                res.data.response.id
            );
          }
        }).catch((err) =>{
          console.error("dev.uploadImages FILE ERROR", err)
        }).finally(() => {
          this.is_loading = false;
        })
      }
      this.status.is_upload_btn = false;
      if(this.$refs.uploadButton) {
        this.$refs.uploadButton.value = null;
      }
    },
    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      if(files.length > 0) {
        //todo check valid image
        this.status.is_upload_btn = true;
        this.uploadImagesFiles = files;
      }else{
        this.status.is_upload_btn = false;
        this.uploadImagesFiles = [];
      }
    },
  },
  watch: {
    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel( newVal){
      this.$emit('update:modelValue', newVal )
    },
  },
};
</script>